import { render, staticRenderFns } from "./SearchLedger.vue?vue&type=template&id=2bc9fbd7&"
import script from "./SearchLedger.vue?vue&type=script&lang=js&"
export * from "./SearchLedger.vue?vue&type=script&lang=js&"
import style0 from "./SearchLedger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports